import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { WAVE_HEIGHT_LEGEND } from './wave-height.legend';
import { WAVE_HEIGHT_PRODUCT_DATA } from './wave-height.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class WaveHeightPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(WAVE_HEIGHT_PRODUCT_DATA, {
    legend: WAVE_HEIGHT_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
